import Windowsticker from './windowsticker';
import { ClientStickerPart } from './client-sticker-part';

// Only intended for use with client base project order form
export class ClientWindowSticker extends Windowsticker {
  clientStickerParts?: ClientStickerPart[];
  calculatedTypeLabel?: string;

  // display only
  calculatedPriceDisplay?: any;

  constructor() {
    super();
    this.type = 'ClientWindowSticker';
  }
}

export const CLIENT_WINDOW_STICKER_TYPE = 'ClientWindowSticker';
